﻿import React from 'react';
import Lottie from 'lottie-react';

import UspText from '../Texts/UspText';

import checkAnimData from '../../../../AnimationFiles/check.json';

const CheckmarkAnimation = (props) => {

    const ref = React.useRef();
    const index = props.i;
    const isVisible = props.inViewport;

    React.useEffect(() => {
        setTimeout(() => {
            if (isVisible === true) {
                if (ref && ref.current) {
                    ref.current.play();
                }
            }
        }, index * 1000 + 500)
    }, [ref, index, isVisible]);


    return (      
        <li>
            <Lottie
                className="school-directors-campaign__usp__container__animation"
                autoplay={false}
                loop={false}
                animationData={checkAnimData}
                lottieRef={ref}
            />
            <UspText heading={props.heading} text={props.text} />
         </li>
     )
 }                

export default CheckmarkAnimation;